import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';

class WatchlistApprovalProvider extends BaseApi {
	approveItem(id: number, remark: string | null) {
		return this.post(`${this.apiPath}ApproveVehicle?detailID=${id}&remark=${remark}`);
	}

	rejectItem(id: number, remark: string | null) {
		return this.post(`${this.apiPath}RejectVehicle?detailID=${id}&remark=${remark}`);
	}

	async sendEmail(emailTemplateFilter: Object) {
		return this.post(`${this.apiPath}SendEmail`, emailTemplateFilter);
	}
}

export const apiProvider = new WatchlistApprovalProvider(DMS_MODULE, NAME);
